module.exports = __webpack_public_path__ + "static/media/cover-form.83846ae2.jpg";